// The Margins — custom reactions
// Each reaction describes what the piece *did* to the reader.
// Not sentiment, not rating — intellectual impact.
export const REACTIONS = [
  {
    key: 'sits_with_me',
    label: 'Sits With Me',
    desc: "I'll be thinking about this later",
    symbol: '◐',
    weight: 3,
  },
  {
    key: 'shifts_something',
    label: 'Shifts Something',
    desc: 'Changed how I see this',
    symbol: '↻',
    weight: 4,
  },
  {
    key: 'needed_saying',
    label: 'Needed Saying',
    desc: 'Someone had to write this',
    symbol: '◉',
    weight: 3,
  },
  {
    key: 'pushes_back',
    label: 'I Push Back',
    desc: 'Disagree — but it deserves the argument',
    symbol: '⇌',
    weight: 2,
  },
  {
    key: 'brought_here',
    label: 'Brought Me Here',
    desc: 'Why I come to The Margins',
    symbol: '◈',
    weight: 5,
  },
]

// Resonance score: weighted reactions + comment bonus
// Returns a number 0-100 normalised, plus a label
export function calcResonance(reactionCounts, commentCount) {
  const rawScore = REACTIONS.reduce((sum, r) => {
    return sum + (reactionCounts[r.key] || 0) * r.weight
  }, 0) + commentCount * 3  // comments weighted at 3

  // Normalise to a 0-100 scale using a log curve so it feels human
  // A score of ~10 weighted reactions = ~40, ~30 = ~70, ~60 = ~90
  if (rawScore === 0) return { score: 0, label: null }
  const normalised = Math.min(100, Math.round(Math.log(rawScore + 1) * 22))
  let label
  if (normalised >= 80) label = 'deeply resonant'
  else if (normalised >= 60) label = 'resonant'
  else if (normalised >= 40) label = 'finding its readers'
  else if (normalised >= 20) label = 'early signal'
  else label = 'just published'
  return { score: normalised, label }
}
